import i18n from "@/language/i18n";
import CONTACT_WIDGETS from "../widgets/CONTACT_WIDGETS";

const CONTACT_MODULE_WINDOW_IDENTIFIER = Object.freeze({
    CONTACTS_MODULE_WINDOW_ID: 'contacts',
});

export { CONTACT_MODULE_WINDOW_IDENTIFIER };

export default {
    CONTACT_GROUP_WRAPPER: {
        type: 'group',
        id: 'contact',
        label: i18n.t('ModuleRegistry.groups.contact.name'),
        children: [],
        icon: '$wCall',
        sidebarIcon: '$wNavContacts'
    },
    CHILDREN: {
        CONTACTS_MODULE: {
            type: 'module',
            id: 'contacts',
            windowIdentifierType: CONTACT_MODULE_WINDOW_IDENTIFIER.CONTACTS_MODULE_WINDOW_ID,
            label: i18n.t('ModuleRegistry.groups.contact.contacts.label'),
            navigationImg: require('@/assets/navigation/items/icon_kontakte.svg'),
            routerLink: '/contacts',
            globalSearch: {
                index: 'contacts',
                presentation: i18n.t('ModuleRegistry.groups.contact.contacts.presentation'),
                component: 'ContactItem.vue',
                shortcut: '-c'
            },
            widgets: CONTACT_WIDGETS.CONTACT_WIDGETS
        },
    }
}
